import Const from 'constants';
import {LineupPlayers as CfbLineupPlayers} from './sports/cfb';
import {LineupPlayers as MlbLineupPlayers} from './sports/mlb';
import {LineupPlayers as NbaLineupPlayers} from './sports/nba';
import {LineupPlayers as NflLineupPlayers} from './sports/nfl';

const componentMap = {
    [Const.LEAGUE_CFB]: CfbLineupPlayers,
    [Const.LEAGUE_MLB]: MlbLineupPlayers,
    [Const.LEAGUE_NBA]: NbaLineupPlayers,
    [Const.LEAGUE_NFL]: NflLineupPlayers,
};

const Factory = {
    getComponent(sportConfig) {
        const sport = sportConfig.getSport().toLowerCase();

        if (componentMap.hasOwnProperty(sport)) {
            return componentMap[sport];
        }

        throw new Error(`Factory ERR: unknown sport ${sport}`);
    },
};

export {Factory};
